import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  UseFormReturnType,
  Validator,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import { Params } from "react-router-dom";
import {
  getRedflagPartnerService,
  RedflagPartnerItem,
  RedflagPartnerOptions,
} from "./redflagPartnerApi";

export interface UseRedflagPartnerFormProps extends GridModalFormProps {}

export interface UseRedflagPartnerFormReturnType
  extends UseFormReturnType<RedflagPartnerItem, RedflagPartnerOptions> {
  params?: Readonly<Params<"redflag_partner_id">>;
}

export default function useRedflagPartnerForm({
  id,
  afterSave,
  defaultValues,
}: UseRedflagPartnerFormProps): UseFormReturnType<
  RedflagPartnerItem,
  RedflagPartnerOptions
> & { params?: any } {
  const params = useParams();
  const scope = undefined;
  const service = getRedflagPartnerService(scope);

  const form = useForm<RedflagPartnerItem, RedflagPartnerOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "RedflagPartner",
    rules: {
      name: Validator.rule.string().required(),
      reason: Validator.rule.string(),
    },
    afterSave,
    defaultValues,
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });

  return { ...form, params };
}
